import React from 'react';
import { Box, Typography } from '@mui/material';
import { RichTextEditorComponent, Toolbar, Inject, HtmlEditor, QuickToolbar, PasteCleanup, Count, Image, Link } from '@syncfusion/ej2-react-richtexteditor';
import { useAppDispatch, useAppSelector } from '../../../../../app/store';
import { updatePolicy } from '../../../../../services/CaseManagementService/policySlice';

const PolicySummaryEditor: React.FC = () => {
  const dispatch = useAppDispatch();
  const policy = useAppSelector((state) => state.policy.currentPolicy);

  const handleChange = (args: any) => {
    dispatch(updatePolicy({ policySummary: args.value }));
  };

  return (
    <Box>
      <Typography variant="subtitle2" color="#1e293b" fontWeight={600} sx={{ mb: 1 }}>
        Policy Summary
      </Typography>
      <RichTextEditorComponent
        value={policy?.policySummary || ''}
        change={handleChange}
        placeholder="Enter detailed policy summary with formatting..."
        height={900}
        toolbarSettings={{
          items: ['Bold', 'Italic', 'Underline', '|', 
                  'Formats', 'FontName', 'FontSize', 'FontColor', 'BackgroundColor', '|',
                  'NumberFormatList', 'BulletFormatList', '|',
                  'Outdent', 'Indent', '|', 'Alignments', '|',
                  'CreateLink', 'Image', '|', 'ClearFormat', 'SourceCode', '|',
                  'Undo', 'Redo']
        }}
        quickToolbarSettings={{
          image: ['Replace', 'Align', 'Caption', 'Remove', 'InsertLink', 'OpenImageLink', '-', 'EditImageLink', 'RemoveImageLink', 'Display', 'AltText', 'Dimension'],
          link: ['Open', 'Edit', 'UnLink']
        }}
        pasteCleanupSettings={{
          prompt: false,
          plainText: false,
          keepFormat: true
        }}
        showCharCount={true}
        maxLength={10000}
        enableResize={false}
        cssClass="policy-summary-editor"
      >
        <Inject services={[Toolbar, HtmlEditor, QuickToolbar, PasteCleanup, Count, Image, Link]} />
      </RichTextEditorComponent>
    </Box>
  );
};

export default PolicySummaryEditor;
